const request = require('../request-utils.js');
import { getCustomerInfoFromCache } from '../api-utils/api-customer.js';
import { Message } from 'element-ui';

/**
 * 获取收钱吧POS收银台统一下单结果
 * @param {*} totalAmount 
 * @param {*} tradeNo 
 * @param {*} outTradeNo 
 * @param {*} payScene 
 * @param {*} payPurpose 
 */
const getShouqianbaPayUrl = async (totalAmount, tradeNo, outTradeNo, payScene, payPurpose) => {
	try {
		// 组装支付请求参数
		let reqData = {
			tradeNo,
			outTradeNo,
			totalAmount,
			payScene,
			payPurpose,
			isQrCode: true,
			payType: "shouqianba",
			paymentPlatform: "shouqianba"
		};

		// 请求支付接口
		let res = await _unifiedOrderFromOrigin(reqData);
		return res.codeUrl || "";
	} catch (e) {
		return "";
	}
}

/**
 * 统一下单请求
 * @param {*} reqData 
 */
const _unifiedOrderFromOrigin = (reqData) => {
	return new Promise(async (resolve, reject) => {
		// 获取客户信息
		let customerInfo = await getCustomerInfoFromCache()

		// 公共参数补充
		reqData.channelId = localStorage.getItem('pc_channelId'); // 支付渠道
		reqData.requestSource = 1; // 请求来源：0 小程序，1 PC
		reqData.isCreditConditionValidateRequest = customerInfo.debtCondition && !!customerInfo.debtCondition.explain; // 是否校验逾期

		request.default.jackyunPost({
			method: "jmall.pay.unifiedorder",
			jsonStr: JSON.stringify(reqData)
		}, (res) => {
			let data = {};
			if (res.code == 200) {
				data = res.result.data;
			} else {
				data.error = res.msg;
				Message.error(res.msg || "下单失败，请联系管理员")
				console.log("统一下单请求失败:", res);
			}
			resolve(data);
		});
	});
}

/**
 * 查询大额支付 银行卡数据
 */
const getBanklistOfBigAmountPay = () => {
	return new Promise((resolve, reject) => {

		request.default.jackyunPost({
			method: "jmall.pay.getbanklist",
			jsonStr: JSON.stringify({})
		}, (res) => {
			let data = [];
			if (res.code == 200) {
				data = res.result.data && res.result.data.split(',') || []
			}
			resolve(data);
		});
	});
}

/**
 * 获取汇付斗拱统一下单结果
 */
const getHuifuPayInfo = async ({
	tradeNo,
	outTradeNo,
	totalAmount,
	payScene,
	payPurpose,
	huifuTypeData,
	bankCardNo,
	idCardName,
	openingBank,
	belongBankName
} = {}) => {
	try {
		// 组装支付请求参数
		let reqData = {
			tradeNo,
			outTradeNo,
			totalAmount,
			payScene,
			payPurpose,
			isQrCode: huifuTypeData.isQrCode,
			payType: huifuTypeData.payType,
			paymentPlatform: huifuTypeData.paymentPlatform || "huifudg",
			bankCardNo,
			idCardName,
			openingBank,
			belongBankName
		};

		// 请求支付接口
		let res = await _unifiedOrderFromOrigin(reqData);


		return {
			error: res.error,
			data: huifuTypeData.isQrCode ? res.codeUrl : JSON.parse(res.payInfo || '{}')
		};
	} catch (e) {
		return {};
	}
}

/**
 * 获取汇付斗拱 支付二维码
 */
const getHuiFuPayUrl = async (huifuPayData = {}) => {
	return await getHuifuPayInfo(huifuPayData);
}

/**
 * 获取微信 支付宝 银联 支付二维码
 * @param {*} totalAmount 
 * @param {*} tradeNo 
 * @param {*} outTradeNo 
 * @param {*} payScene 
 * @param {*} payPurpose 
 */
const getPayUrlForWxAliUnion = async (payData = {}) => {
	try {
		payData.isQrCode = true;

		// 请求支付接口
		let res = await _unifiedOrderFromOrigin(payData);
		return res.codeUrl || "";
	} catch (e) {
		return "";
	}
}

/**
 * 线下支付
 * @param {*} totalAmount 
 * @param {*} tradeNo 
 * @param {*} outTradeNo 
 * @param {*} payScene 
 * @param {*} payPurpose 
 */
const offlineUnifiedOrder = async (offlinePayData = {}) => {
	try {
		offlinePayData.isQrCode = false;
		offlinePayData.fullyPaid = true;

		// 请求支付接口
		let res = await _unifiedOrderFromOrigin(offlinePayData);
		return res || {};
	} catch (e) {
		return {};
	}
}

export {
	getShouqianbaPayUrl,
	getHuiFuPayUrl,
	getHuifuPayInfo,
	getBanklistOfBigAmountPay,
	getPayUrlForWxAliUnion,
	offlineUnifiedOrder
}